import { useUnit } from '@hook'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  id?: string
  onClose: () => void
}

export const RemoveUnit = ({ onClose, id }: Props) => {
  const { deleteUnit } = useUnit({})
  const [isLoading, setIsLoading] = useState(false)

  // const handleClose = () => {
  //   onClose()
  //   setIsLoading(false)
  // }

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await deleteUnit(id as string)
      onClose()
      showToast('Unit deleted successfully')
      setIsLoading(false)
    } catch (error) {
      getError(error)
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <DeleteModal
      description="Confirm that you want to delete this unit"
      handleSubmit={handleDelete}
      isLoading={isLoading}
      onClose={onClose}
      title="Delete Healtcare Unit"
    />
  )
}
